import React, {Fragment, useState} from 'react';
import { Table, Button, Modal } from 'antd';
import {Link} from 'react-router-dom';
import {PrescriptionLogsData} from "../../types/PrescriptionLogsData";
import {formatDateToFullString} from "../../util/date";
import {useTexts} from "../../hooks/useTexts";

const PrescriptionLogsTable = ({data}: { data: PrescriptionLogsData }): JSX.Element => {
    const {t} = useTexts();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRequestBody, setSelectedRequestBody] = useState<any>(null);

    const handleOpenDialog = (requestBody: any) => {
        setSelectedRequestBody(requestBody);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedRequestBody(null);
    };

    const columns = [
        {
            title: t('prescription', 'user') || 'User',
            dataIndex: ['user', 'username'],
            key: 'user',
        },
        {
            title: t('prescription', 'viewPrescription') || 'View Prescription',
            key: 'viewPrescription',
            render: (_: any, record: any) => (
                <Link target={"_blank"} to={"/prescriptions/" + record.prescription?.id}>
                    {t('prescription', 'viewPrescription') || 'View Prescription'}
                </Link>
            ),
        },
        {
            title: t('prescription', 'contactNumber') || 'Contact Number',
            key: 'contactNumber',
            render: (_: any, record: any) => (
                <Fragment>
                    {record.prescription.phoneNumber}
                    {record.prescription.additionalPhoneNumber && `, ${record.prescription.additionalPhoneNumber}`}
                </Fragment>
            ),
        },
        {
            title: t('prescription', 'status') || 'Status',
            dataIndex: ['requestBody', 'status'],
            key: 'status',
            render: (status: any) => status || '-',
        },
        {
            title: t('prescription', 'note') || 'Note',
            dataIndex: ['requestBody', 'note'],
            key: 'note',
            render: (note: any) => note?.length > 30 ? note.substring(0, 30) + " ..." : note || '-',
        },
        {
            title: t('prescription', 'logType') || 'Log Type',
            dataIndex: 'logType',
            key: 'logType',
            render: (logType: any) => logType || '-',
        },
        {
            title: t('prescription', 'createdAt') || 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (createdAt: any) => !!createdAt ? formatDateToFullString(new Date(createdAt)) : "-",
        },
        {
            title: 'Log',
            key: 'log',
            align: 'center' as const,
            render: (_: any, record: any) => (
                <Button size="small" onClick={() => handleOpenDialog(record.requestBody)}>
                    {t('prescription', 'showLog') || 'Show Logs'}
                </Button>
            ),
        },
    ];

    return (
        <Fragment>
            <div style={{ marginBottom: 16 }}>{t('common', 'totalCount') || 'Total'}: {data.pagination.elementCount}</div>
            <Table
                dataSource={data.items}
                columns={columns}
                rowKey="id"
                pagination={false}
                scroll={{ x: 650 }}
            />

            <Modal 
                title={t('prescription', 'logDetails') || 'Log Details'}
                open={openDialog} 
                onCancel={handleCloseDialog}
                footer={[
                    <Button key="close" type="primary" onClick={handleCloseDialog}>
                        {t('common', 'close')}
                    </Button>
                ]}
                width={800}
            >
                <pre style={{
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-all',
                    margin: 0,
                    backgroundColor: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '4px'
                }}>
                    {selectedRequestBody ? JSON.stringify(selectedRequestBody, null, 2) : ''}
                </pre>
            </Modal>
        </Fragment>
    );
}

export default PrescriptionLogsTable;